import { Component, OnInit } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ApiService } from '../../services/api.service';
import { ApiAnalyticsService } from '../../services/api-analytics.service';
import { DataService } from "../../services/data.service";
import { Subscription } from 'rxjs';
import { COUNTRY, URL_IMG, URL_EXT} from '../../constants/general';
import { ModelCountries } from '../../models/catalogs';

@Component({
  selector: 'app-general-data',
  templateUrl: './general-data.component.html',
  styleUrls: ['./general-data.component.scss'],
  host:{
    'class':'col forms-common-style d-flex justify-content-center first-general-content position-relative'
  }
})
export class GeneralDataComponent implements OnInit {

  form: UntypedFormGroup;
  countries:ModelCountries[]=[]; 
  countriesSelect:ModelCountries[]=[];
  name:string;
  subscription: Subscription;
  url=URL_EXT;
  url_img = URL_IMG;   
  selectedImgContry= this.url_img.default_country;  
  generalData = {
    cx_nombre:'',
    cx_apellido_p:'',
    cx_apellido_m:'',
    cx_correo:'',
    cx_pais:'MX',
    int_telefono:'',
    cx_folio:0
  };
  msgErrorEmail:string='';
  msgErrorPhone:string='';
  from:string='';

  constructor(private activatedRoute:ActivatedRoute,
              private formBuilder: UntypedFormBuilder,
              private router: Router,
              private spinner: NgxSpinnerService,
              private api: ApiService,
              private apiAnalytics :ApiAnalyticsService,
              private data: DataService) 
  { 
    this.validateSession();
    this.buildForm();
    this.getCountries();         
  }

  ngOnInit(): void {
    this.setValuesFromURL();    
    window.scrollTo(0, 0);
    this.data.setStep('registro');
    this.subscription = this.data.currentName.subscribe(name => this.name = name);
  }

  previous() {
    let url = window.location.origin;
    if(this.data.fromValue==='banner') {
      if(url.indexOf('bursanet.mx') > 0) {
        window.location.href='https://www.bursanet.mx/crear-cuenta-bursanet.html';
      } else{
        window.location.href='https://bursanetmx-qa.actinver.com.mx/crear-cuenta-bursanet.html';
      }
    } else {
      if(url.indexOf('bursanet.mx') > 0) {
        window.location.href='https://www.bursanet.mx';
      } else{
        window.location.href='https://bursanetmx-qa.actinver.com.mx';
      }
    }
  }

  setValuesFromURL():void{

    this.from = this.activatedRoute.snapshot.paramMap.get('from') || '';    
    this.data.fromValue=this.from;

    this.activatedRoute.queryParams
      .subscribe((params:any) => {
        if(params!==undefined){
          if(params?.nombre!==undefined){
            this.nameInput.setValue(params.nombre.toString().toUpperCase())
          }

          if(params?.apellidop!==undefined){
            this.surnamePInput.setValue(params.apellidop.toString().toUpperCase())
          }

          if(params?.apellidom!==undefined){
            this.surnameMInput.setValue(params.apellidom.toString().toUpperCase())
          }

          if(params?.email!==undefined){
            this.emailInput.setValue(params.email.toString().toUpperCase())
          }

          if(params?.celular!==undefined){
            this.phoneInput.setValue(Number(params.celular.toString().slice(0,10)))
          }
        }
      }
    );
  }

  validateSession() {    
    if( sessionStorage.getItem('general_data') ) {
      this.generalData = JSON.parse( sessionStorage.getItem('general_data') );    
      this.selectedImgContry = this.url_img.countries + this.generalData.cx_pais.toLowerCase()+'.svg'; 
    }
  }

  private buildForm() {
    this.form = this.formBuilder.group({
      cx_nombre: [this.generalData.cx_nombre, [Validators.required] ],
      cx_apellido_p: [this.generalData.cx_apellido_p, [Validators.required] ],
      cx_apellido_m: [this.generalData.cx_apellido_m, [Validators.required] ],
      cx_correo: [this.generalData.cx_correo, [Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'), Validators.email, Validators.required]],
      int_telefono: [this.generalData.int_telefono, [Validators.pattern('^[0-9]*$'), Validators.maxLength(10), Validators.minLength(10), Validators.required]],
      cx_folio: [this.generalData.cx_folio]
    })
  }

  get nameInput() {
    return this.form.get('cx_nombre');
  }

  get surnamePInput() {
    return this.form.get('cx_apellido_p');
  }

  get surnameMInput() {
    return this.form.get('cx_apellido_m');
  }

  get emailInput() {
    return this.form.get('cx_correo');
  }

  get phoneInput() {
    return this.form.get('int_telefono');
  }

  showErrorEmail():boolean {
    if(this.emailInput.invalid && this.emailInput.touched && this.emailInput.dirty) {
      if(this.emailInput.value == '') {
        this.msgErrorEmail='Dato requerido';
        return true;
      } else {
        this.msgErrorEmail='El dato ingresado es inválido';
        return true;
      }
      
    } else {
      return false;
    }    
  }

  showErrorPhone():boolean {
    if(this.phoneInput.invalid && this.phoneInput.touched && this.phoneInput.dirty) {
      if(this.phoneInput.value == '') {
        this.msgErrorPhone='Dato requerido';
        return true;
      } else {
        this.msgErrorPhone='El dato ingresado es inválido';
        return true;
      }
      
    } else {
      return false;
    }    
  }
  

  getCountries() {
    this.spinner.show();
    this.api.getCountries().subscribe((data: ModelCountries[]) => {
      this.spinner.hide();
      this.countries = data;
      this.reOrderCountries();
    }, error => {
      this.spinner.hide();
    });
  }
  
  reOrderCountries() {
    this.countriesSelect[0]=COUNTRY;
    let count=1;
    Object.keys(this.countries).map((key) => {
      switch(this.countries[key].land1){
        case 'US':
          break;
        case 'EXT':
          break;
        case 'NRE':
          break;
        default:
          this.countriesSelect[count]=this.countries[key];
          count++;
        break;
      }      
    });    
  }

  setCountry(country): void {
    this.generalData.cx_pais = country;
    this.selectedImgContry='assets/img/countries/'+ country.toLowerCase() +'.svg';
  }

  saveStepOne(event:Event) {

    event.preventDefault();
    this.form.markAllAsTouched();

    if(this.form.valid) {

      this.spinner.show();      
      
      const dataForm = {
        cx_nombre: this.form.value.cx_nombre,
        cx_apellido_p: this.form.value.cx_apellido_p,
        cx_apellido_m: this.form.value.cx_apellido_m,
        cx_correo: this.form.value.cx_correo,
        cx_pais: this.generalData.cx_pais,
        int_telefono: this.form.value.int_telefono,
        cx_folio: this.generalData.cx_folio
      }      

      this.apiAnalytics.email = this.form.value.cx_correo;
      this.apiAnalytics.phone = this.form.value.int_telefono;
      
      this.api.saveStepOne(dataForm).subscribe((data: any) => {

        this.apiAnalytics.gTag(`Landing | Registrate | Continuar`, 'Landing | Registrate', 'Tres Pasos Bursanet','1');
                
        const dataSession = {
          cx_nombre: this.form.value.cx_nombre.trim(),
          cx_apellido_p: this.form.value.cx_apellido_p.trim(),
          cx_apellido_m: this.form.value.cx_apellido_m.trim(),
          cx_correo: this.form.value.cx_correo,
          cx_pais: this.generalData.cx_pais,
          int_telefono: this.form.value.int_telefono,
          cx_folio: data.valReturn
        }
        
        
        sessionStorage.removeItem('general_data');
        sessionStorage.setItem('general_data', JSON.stringify(dataSession) );
        this.data.updateName(this.form.value.cx_nombre);
        
        this.spinner.hide();
        this.router.navigate(['/opciones/autonomo-identificacion']); 

      }, error => {

        this.spinner.hide();
      });
    }
  }

}
